import { useContext, useEffect, useRef, useState } from 'react'
import SalesCodeComplexityRow from './SalesCodeComplexityRow'
import {
  SalesCodeComplexityContext,
  SET_SALES_CODE_PLUGIN_DATA,
  SET_SHOW_HIDE_DETAILS_POPUP,
  SET_SHOW_HIDE_ERROR_LOGS,
  SET_SHOW_HIDE_FORM_POPUP,
  SET_UPLOAD_FILE_STATUS,
} from './context/context'
import {
  deleteRequest,
  getRequest,
  postRequest,
} from '../../../../services/base'
import { createSearchParams, useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import LinkWithStatus from '../../../common/LinkWithStatus'
import NoRecordsFound from '../../../common/NoRecordsFound'
import Pagination from '../../../common/Pagination'
import SalesCodeComplexityFormModal from './form'
import SalesCodeDetails from './SalesCodeDetails'
import InputText from '../../../common/InputText'
import Button from '../../../common/Button'
import { Download, CloudUpload, InfoCircle } from '@styled-icons/boxicons-solid'
import DropDownMenu from '../../../common/DropDownMenu'
import { ProgresSpinner } from '../../../common/ProgresSpinner'
import SalesCodeErrorLogs from './error_logs/SalesCodeErrorLogs'
import { getSessionStorageData } from '../../../../utils/SessionStorage'

const SalesCodeComplexity = () => {
  const { vehicle } = useParams()

  const [salesCodeState, salesCodeDispatch] = useContext(
    SalesCodeComplexityContext
  )
  const [state, dispatch] = useContext(NavContext)
  const [pagination, setPagination] = useState({})
  const [searchValue, setSearchValue] = useState('')
  const vehicle_redirect_url = getSessionStorageData('vehicle')?.search
    ? `/vehicles/?${createSearchParams(getSessionStorageData('vehicle'))}`
    : `/vehicles`
  const currentUrl = useRef(
    `/api/plugin/sales_code/?vehicle=${vehicle}&search=${searchValue}`
  )

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        header: vehicle,
        sub_header: 'Sales Code Complexity Plugin',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: vehicle_redirect_url,
        full_width_container: false,
      },
    })

    const statusInt = setInterval(fetchComplexityStatusInterval, 10000)

    getSalesCodeComplexityData('', true)
    fetchComplexityStatusInterval()

    const salesCodeDataInterval = setInterval(getSalesCodeComplexityData, 30000)

    return () => {
      clearInterval(statusInt)
      clearInterval(salesCodeDataInterval)
    }
  }, [])

  const fetchComplexityStatusInterval = async () => {
    let res = await getRequest(
      `/api/plugin/sales_code/upload_status_check/${vehicle}/?vehicle=${vehicle}`
    )
    if (res?.status) {
      salesCodeDispatch({
        type: SET_UPLOAD_FILE_STATUS,
        data: { ...res.data },
      })
    }
  }

  const getSalesCodeComplexityData = async (url = null, showLoader = false) => {
    if (showLoader) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Fetching Sales Code Data',
          showLoader: true,
        },
        notification: {},
      })
    }

    let response = await getRequest(currentUrl.current)
    salesCodeDispatch({
      type: SET_SALES_CODE_PLUGIN_DATA,
      data: response.results,
    })
    setPagination(response.pagination)
    if (showLoader) {
      dispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
    }
  }

  const downloadSalesCodeFile = async (download_option = null) => {
    if (
      window.confirm(
        `Are you sure want to download ${download_option} Sales Code Complexity`
      ) === true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: 'Downloading Sales Code Complexity..',
          showLoader: true,
        },
        notification: {},
      })

      let formData = new FormData()
      if (download_option == 'All') {
        formData.append('sales_code', 'All')
      } else {
        salesCodeState.selectedIds.forEach((element) => {
          formData.append('sales_code', element)
        })
      }
      formData.append('vehicle', vehicle)

      let res = await postRequest(
        `/api/plugin/sales_code/bulk/download/`,
        formData,
        true
      )
      if (res?.msg) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
            loader: true,
          },
        })
      } else {
        const url = window.URL.createObjectURL(new Blob([res]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `${vehicle}_sales_code_complexity.csv`)
        document.body.appendChild(link)
        link.click()
        link.remove()

        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'File downloaded successfully',
            loader: true,
          },
        })
      }
    }
  }

  const deleteSalesCodeComplexity = async (sales_code_id) => {
    if (
      window.confirm('Are you sure to delete Sales Code Complexity') == true
    ) {
      let res = await deleteRequest(
        `/api/plugin/sales_code/${sales_code_id}/?vehicle=${vehicle}`
      )
      getSalesCodeComplexityData(null, true)
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'Sales Code Complexity Successfully deleted!',
        },
      })
    }
  }

  return (
    <div className="w-full">
      <SalesCodeComplexityFormModal
        getSalesCodeComplexityData={getSalesCodeComplexityData}
      />
      <SalesCodeErrorLogs />
      <SalesCodeDetails />
      <form
        className="flex flex-col w-full space-y-2 pb-2"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div
          className={`flex space-x-5 justify-between content-center items-center`}
        >
          <div className="flex items-center w-1/2">
            <div className="flex items-center w-full">
              <InputText
                name="search_value"
                placeholder={`Search Sales Complexity`}
                className={`w-100`}
                value={searchValue}
                isFullSize={true}
                type="search"
                onChange={(value) => {
                  setSearchValue(value)
                }}
                isRequired={false}
              />
              <Button
                className={`cursor-pointer btn my-4 justify-end`}
                text={`Search`}
                onClick={() => {
                  currentUrl.current = `/api/plugin/sales_code/?vehicle=${vehicle}&search=${searchValue}`
                  getSalesCodeComplexityData('', true)
                }}
              />
            </div>
          </div>

          <div className="w-2/3 flex font-light text-right space-x-5 justify-end content-center items-center">
            {salesCodeState?.in_process_upload_files && (
              <LinkWithStatus
                href={`/vehicles/${vehicle.vehicle_id}/progress`}
                className="btn py-2 px-3 flex"
                title="Download"
                onClickFunc={() => {}}
                key={`upload-sales-file-status`}
              >
                <ProgresSpinner caption="File Upload In Progress" />
                <CloudUpload
                  size="1.5rem"
                  color="white"
                  key={`upload-sales-file-status`}
                />
              </LinkWithStatus>
            )}

            <LinkWithStatus
              href={`/vehicles/${vehicle.vehicle_id}/errors`}
              className="btn py-2 px-3 flex"
              title="Error"
              onClickFunc={() => {
                salesCodeDispatch({
                  type: SET_SHOW_HIDE_ERROR_LOGS,
                  data: true,
                })
              }}
              key={`upload-sales-file-errors`}
            >
              <InfoCircle
                size="1.5rem"
                color="white"
                key={`upload-sales-file-errors`}
              />
            </LinkWithStatus>
            <DropDownMenu
              items={[
                { name: 'Download All Files', value: 'All' },
                {
                  name: 'Download Selected Files',
                  value: 'Download Selected Files',
                },
              ]}
              onClick={(item) => {
                downloadSalesCodeFile(item.value)
              }}
              showMenu={salesCodeState?.selectedIds?.length > 0}
              key={`download-sales-code`}
            >
              <LinkWithStatus
                href={`/vehicles/${vehicle.vehicle_id}/edit`}
                className="btn py-2 px-3"
                title="Download"
                onClickFunc={() => {}}
                key={`download-sales-code-link`}
              >
                <Download
                  size="1.5rem"
                  color="white"
                  key={`download-sales-code-icon`}
                />
              </LinkWithStatus>
            </DropDownMenu>
            <LinkWithStatus
              href={`/administration/system/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Upload New File"
              onClickFunc={() => {
                salesCodeDispatch({
                  type: SET_SHOW_HIDE_FORM_POPUP,
                  data: true,
                })
              }}
            />
          </div>
        </div>
      </form>

      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-1/12 items-center justify-center"></div>
          <div className="flex w-3/12 items-center">Harness</div>
          <div className="flex w-3/12 pl-6 items-center">Harness Type</div>
          <div className="flex w-3/12 pl-6 items-center">Date</div>
          <div className="flex w-2/12 pl-6 items-center"></div>
        </div>
      </div>
      {salesCodeState?.data?.map((sales_code_complexity, index) => {
        return (
          <SalesCodeComplexityRow
            {...sales_code_complexity}
            onDelete={() => {
              deleteSalesCodeComplexity(sales_code_complexity.id)
            }}
            key={`sales-code-complexity-${index}`}
            onShowDetails={() => {
              salesCodeDispatch({
                type: SET_SHOW_HIDE_DETAILS_POPUP,
                data: sales_code_complexity,
              })
            }}
          />
        )
      })}

      {salesCodeState?.data?.length < 1 && (
        <NoRecordsFound
          caption={'Sales Code Complexity not found'}
          loading={false}
        />
      )}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            currentUrl.current = e
            getSalesCodeComplexityData(e, true)
          }}
          onClickPrev={(e) => {
            currentUrl.current = e
            getSalesCodeComplexityData(e, true)
          }}
        />
      </div>
    </div>
  )
}

export default SalesCodeComplexity
